import { useEffect, useState } from 'react';
import { Button } from '../../atoms/Button';
import { Typography } from '../../molecules/Typography';

import logoMiniColor from '../../../../assets/images/brand/logo-mini-color.svg';

declare global {
  interface Window {
    MSStream: any;
  }
}

export function SmartBanner() {
  const [isMobile, setIsMobile] = useState(false);
  const appStoreLink = /android/i.test(navigator.userAgent)
    ? 'https://play.google.com/store/apps/details?id=br.com.aprovatotal&hl=en_US'
    : 'https://apps.apple.com/br/app/aprova-total-curso-enem/id1462286487';

  useEffect(() => {
    const isBannerClosed = localStorage.getItem('at:mobile:bannerClosed');
    const userAgent = navigator.userAgent || navigator.vendor;
    if (
      (/android/i.test(userAgent) ||
        (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) &&
      !isBannerClosed
    ) {
      setIsMobile(true);
    }
  }, []);

  const handleClose = () => {
    setIsMobile(false);
    localStorage.setItem('at:mobile:bannerClosed', 'true');
  };

  if (!isMobile) {
    return null;
  }

  return (
    <div className='text-white sticky left-0 top-[64px] z-50 w-full bg-brand-color-primary-lighter p-4 text-sm shadow-level-1'>
      <div className='flex items-center justify-between gap-md'>
        <Button
          LeftIcon={'clear'}
          iconType={'material'}
          onClick={handleClose}
          variant={'text'}
          iconSize={'small'}
          size={'small'}
          className={'text-brand-color-primary-pure'}
        />
        <div className={'flex items-center gap-sm'}>
          <img src={logoMiniColor} alt='Logo aprova total' />
          <div className={'flex flex-col'}>
            <Typography
              type={'title'}
              size={'h4'}
              className={'text-brand-color-primary-dark'}
            >
              App Aprova Total
            </Typography>
            <Typography
              size={'mini'}
              className={'text-brand-color-primary-dark'}
            >
              Acesse pelo aplicativo do Aprova
            </Typography>
          </div>
        </div>
        <Button asLink to={appStoreLink} target={'_blank'}>
          Abrir
        </Button>
      </div>
    </div>
  );
}
